import { render, staticRenderFns } from "./VWidgetHistoria.vue?vue&type=template&id=31c2a3ee"
import script from "./VWidgetHistoria.vue?vue&type=script&lang=js"
export * from "./VWidgetHistoria.vue?vue&type=script&lang=js"
import style0 from "./VWidgetHistoria.vue?vue&type=style&index=0&id=31c2a3ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports